import { Component, Input, HostBinding, SimpleChanges, EventEmitter, OnInit, OnChanges } from '@angular/core';
import { 
  NbGlobalPhysicalPosition,
  NbGlobalPosition,
  NbComponentStatus,
  NbToastrService 
} from '@nebular/theme';


@Component({
  selector: 'nbx-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  // encapsulation: ViewEncapsulation.ShadowDom
})
export class ButtonComponent  implements OnInit, OnChanges {
  private index: number = 0;

  @Input() label = "button";
  @Input() appearance = "hero";
  @Input() shape = "semi-round";
  @Input() size = "medium";
  @Input() status = "primary";
  @Input() disabled = "false";
  @Input() buttontype = "button";
  @Input() showtoastr = 'no';
  @Input() message = 'Example Message';
  @Input() title = 'Title';
  @Input() icon = '';
  @Input() toaststatus: NbComponentStatus = 'primary';
  @Input() toastposition: string = 'top-right';
  @Input() duration = 2000;

  showNotification = false;

  @HostBinding('class')
  classes = 'example-items-rows';

  constructor(private toastrService: NbToastrService) {
  }

  position = NbGlobalPhysicalPosition.TOP_RIGHT

  ngOnInit() {

    if (this.showtoastr == 'yes')
    {
      this.showNotification = true;
    }
    else 
    {
      this.showNotification = false;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    for (const propName in changes) 
    {
      if (changes.hasOwnProperty(propName))
      {
        if (propName == "showtoastr")
        {
          if (this.showtoastr == 'yes')
          {
            this.showNotification = true;
          }
          else 
          {
            this.showNotification = false;
          }
        }
      }
    }
  }

  showToast() {

    switch(this.toastposition) { 
      case 'top-right': { 
         //statements; 
         this.position = NbGlobalPhysicalPosition.TOP_RIGHT;

         break; 
      } 
      case 'top-left': { 
         //statements; 
         this.position =  NbGlobalPhysicalPosition.TOP_LEFT;

         break; 
      }
      case 'bottom-right': { 
        //statements; 

        this.position = NbGlobalPhysicalPosition.BOTTOM_LEFT;
        break; 
      }
      case 'bottom-left': { 
        //statements; 

        NbGlobalPhysicalPosition.BOTTOM_RIGHT;
        break; 
      }  
      default: { 
         //statements; 
         break; 
      } 
   }; 

    this.index ++;
    const duration = this.duration;
    let status = this.toaststatus;
    let position = this.position;
    this.toastrService.show(
      this.message,
      this.title || 'Title',
      { position, status, duration });
  }


  // @Output() buttonEvt: EventEmitter<string> = new EventEmitter();
}
